'use client'
import Link from 'next/link'
import { usePathname, useSearchParams } from 'next/navigation'
import React from 'react'

const Breadcrumb = ({ category }: any) => {
  const searchParams = useSearchParams()
  const pathname = usePathname()
  const setting = searchParams.get('setting')?.split('-sku-').reverse()[0]
  const diamond = searchParams.get('diamond')?.split('-').reverse()[0]

  if (pathname === '/complete-jewel') {
    return (
      <nav className="breadcrumb_bar">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link href="/">Home</Link>
          </li>
          <li
            className="breadcrumb-item active"
            aria-current="page"
          >
            Complete Jewel
          </li>
        </ol>
      </nav>
    )
  }
  return (
    <>
      {category && Object.keys(category)?.length > 0 ? (
        <nav className="breadcrumb_bar">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link href="/">Home</Link>
            </li>
            {category ? (
              (setting || diamond) && category ? (
                <>
                  <li
                    className="breadcrumb-item"
                    aria-current="page"
                  >
                    <Link href={category.slug}>{category.title}</Link>
                  </li>
                  <li
                    className="breadcrumb-item active"
                    aria-current="page"
                  >
                    Item #{setting || diamond}
                  </li>
                </>
              ) : category.title !== undefined ? (
                <li
                  className="breadcrumb-item active"
                  aria-current="page"
                >
                  {category.title != null ? category.title : category.name}
                </li>
              ) : (
                <>
                  <li
                    className="breadcrumb-item"
                    aria-current="page"
                  >
                    <Link href={category.slug}>{category.title}</Link>
                  </li>
                  <li
                    className="breadcrumb-item active"
                    aria-current="page"
                  >
                    {category.title}
                  </li>
                </>
              )
            ) : (
              pathname === '/complete-jewel' && (
                <li
                  className="breadcrumb-item active"
                  aria-current="page"
                >
                  Complete Jewel
                </li>
              )
            )}
          </ol>
        </nav>
      ) : null}
    </>
  )
}

export default Breadcrumb
